import type {
    MigrationDoc,
    MigrationRowStatus,
    MigrationStatusText,
} from "./migrationFileMatching.types";

export const EXTRACTION_WARNINGS_MESSAGE: MigrationStatusText = {
    short: "Has warnings",
    tooltip: "Parser found possible completeness issues",
};

export function isMigrationRowReadyForFinalize(
    status: MigrationRowStatus,
): boolean {
    return status === "ready";
}

export function remainingParserWarnings(doc: MigrationDoc): string[] {
    const warnings = doc.warnings;
    if (warnings == null || warnings.length === 0) {
        return [];
    }
    const dismissedCount = doc.dismissedParserWarningCount ?? 0;
    return warnings.slice(dismissedCount);
}

export function hasPendingParserWarnings(doc: MigrationDoc): boolean {
    return remainingParserWarnings(doc).length > 0;
}

export function extractionWarningsStatusText(
    warnings: string[],
): MigrationStatusText {
    return {
        short: EXTRACTION_WARNINGS_MESSAGE.short,
        tooltip: warnings.join("; "),
    };
}
